import React, { ReactNode } from 'react'
import StyledArticle from './styles'
import { AddPaymentMethodForm, Page } from '../../../components'
import { appsStyleSelected } from '../../../helpers/app'
import { LiteralsService, UserService } from '../../../services'
import { ElementsConsumer } from '@stripe/react-stripe-js'
import { connect, DispatchProp } from 'react-redux'
import { AnyAction } from 'redux'
import { AuthenticatedRoutable, IUser } from '../../../models'
import { IStoreState } from '../../../store/states'
import { setUserInfoAction } from '../../../store/actions'
import { images } from '../../../images'

interface IProps extends DispatchProp<AnyAction> {
  userInfo: IUser
}

class PaymentMethod extends AuthenticatedRoutable<IProps> {

  getTitle = () => {
    const { userInfo } = this.props
    return userInfo && userInfo.stripeIds && userInfo.paymentMethodLastFour ? 'changePaymentMethod' : 'addPaymentMethod'
  }

  public componentDidMount(): void {
    super.componentDidMount()
  }

  public render(): ReactNode {
    const { userInfo, dispatch } = this.props

    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className='backButton' onClick={ this.handleGoBack } />
            <h3>{ LiteralsService.get(this.getTitle(), true) }</h3>
            <section>
              { (userInfo && userInfo.stripeIds && userInfo.paymentMethodLastFour)  && 
                <div className="cards-container">
                  <div>
                    <span className='active-card'>
                      { `${LiteralsService.get('activeCard', true)}: ` }
                    </span>
                    <span className='active-card-info'>
                      { `  xxxx xxxx xxxx ${ userInfo?.paymentMethodLastFour }` }
                    </span>
                  </div>
                  <div className="separator"></div>
                </div>
              }
            </section>
            <div className='newcard-text'>
              { `${LiteralsService.get('newCard', true)}:` }
            </div>
            <ElementsConsumer>
              {({stripe, elements}) => {
                return <AddPaymentMethodForm
                  stripe={ stripe! }
                  elements={ elements! }
                  amount={ 1 }
                  isEdit={ userInfo && userInfo.stripeIds && userInfo.paymentMethodLastFour ? true : false }
                  isConfig={ true }
                  dispatch={ dispatch }
                  updateUserInfo={ this.onUpdateUserInfo }
                  close={ () => {
                    this.handleGoBack()
                  } }
                />
              }}
            </ElementsConsumer>
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }
  
  private onUpdateUserInfo = async() => {
    const user = await UserService.getInfo()
    this.props.dispatch(setUserInfoAction(user))
  }

}

const mapStateToProps = ({ userInfo }: IStoreState) => ({
  userInfo: userInfo,
})

export default connect(mapStateToProps) (PaymentMethod)